import { CouriersFiltersType } from '@components/users/couriers/CouriersFilter'
import { makeFilter, makeSearchFilter } from './crud/filters'
import { NestedFilter } from '@@partner:types:graphql'


export const prepareCourierFilter = (filters: CouriersFiltersType): NestedFilter => {
  const idFilter = makeFilter('id', 'eq', filters.id)
  const firstNameFilter = makeSearchFilter('first_name', 'includes', filters.name)
  const lastNameFilter = makeSearchFilter('last_name', 'includes', filters.name)
  const phoneFilter = makeFilter('phone', 'eq', filters.phone)
  const statusFilter = makeFilter(
    'status',
    'contains',
    filters.status?.map(String)
  )
  const shopIdsFilter = makeFilter('shopIds', 'contains', filters.shopIds)
  const zoneIdsFilter = makeFilter('zoneIds', 'contains', filters.zoneIds)

  return {
    and: [
      idFilter,
      {
        or: [
          firstNameFilter,
          lastNameFilter
        ],
      },
      phoneFilter,
      statusFilter,
      shopIdsFilter,
      zoneIdsFilter
    ]
  }
}